var map = {
	"./Main.png": 179,
	"./Main2.png": 72,
	"./images/Andre_Torlen_Lonvik.jpg": 63,
	"./images/IAMK_posters.png": 64,
	"./images/KoLab.png": 65,
	"./images/NTNUI-Redesign.jpg": 66,
	"./images/NewCV_Design.jpg": 67,
	"./images/Web 1920 – 1.png": 68,
	"./images/internship.png": 69,
	"./images/redesign-logo.png": 70,
	"./images/vrIconDesign.png": 71,
	"./json": 2,
	"./json.js": 2,
	"./jsonStruct": 74,
	"./jsonStruct.js": 74,
	"./signature-white.png": 180,
	"./structure": 75,
	"./structure.js": 75,
	"./svg/Adobe_Illustrator_CC_icon.svg": 21,
	"./svg/Adobe_Photoshop_CC_icon.svg": 34,
	"./svg/Adobe_XD_CC_icon.svg": 33,
	"./svg/CSS3_logo_and_wordmark.svg": 36,
	"./svg/Devicon-html5-plain-wordmark.svg": 35,
	"./svg/Javascript-shield.svg": 38,
	"./svg/Python.svg": 37,
	"./svg/React-icon.svg": 41,
	"./svg/SQLite370.svg": 40,
	"./svg/adobe-brands.svg": 181,
	"./svg/figma-1.svg": 42,
	"./svg/flask.svg": 39
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;